var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "file-container" }, [
    _c("div", { staticClass: "main" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.fileLoading,
              expression: "fileLoading",
            },
          ],
          staticClass: "file-list",
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "25px 32px 17px",
                color: "#181F33",
                "font-size": "18px",
              },
            },
            [_vm._v("文件管理")]
          ),
          _c("div", { staticStyle: { "border-top": "1px solid #EDEDED" } }),
          _c(
            "el-row",
            { staticClass: "header" },
            [
              _c(
                "el-col",
                {
                  staticStyle: { "padding-left": "20px" },
                  attrs: { span: 18 },
                },
                [_vm._v("文件名称")]
              ),
              _c("el-col", { attrs: { span: 4 } }, [_vm._v("时间")]),
              _c("el-col", { attrs: { span: 2 } }, [_vm._v("操作")]),
            ],
            1
          ),
          !_vm.totalElements
            ? _c("empty-view")
            : _c(
                "div",
                { staticStyle: { margin: "0 31px" } },
                _vm._l(_vm.fileData, function (item, index) {
                  return _c(
                    "el-row",
                    {
                      key: index,
                      staticClass: "flex justify-between file-item",
                      staticStyle: {
                        "border-bottom": "1px solid #EDEDED",
                        height: "66px",
                      },
                    },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "flex items-center",
                          attrs: { span: 18 },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex items-center",
                              staticStyle: { "margin-left": "20px" },
                            },
                            [
                              _c("div", [
                                item.suffix === "excel"
                                  ? _c("img", {
                                      staticClass: "file-icon",
                                      attrs: { src: _vm.excelBase64, alt: "" },
                                    })
                                  : item.suffix === "xlsx"
                                  ? _c("img", {
                                      staticClass: "file-icon",
                                      attrs: { src: _vm.excelBase64, alt: "" },
                                    })
                                  : item.suffix === "pdf"
                                  ? _c("img", {
                                      staticClass: "file-icon",
                                      attrs: { src: _vm.pdfBase64, alt: "" },
                                    })
                                  : item.suffix === "word" ||
                                    item.suffix === "docx"
                                  ? _c("img", {
                                      staticClass: "file-icon",
                                      attrs: { src: _vm.wordBase64, alt: "" },
                                    })
                                  : item.suffix === "zip"
                                  ? _c("img", {
                                      staticClass: "file-icon",
                                      attrs: { src: _vm.zipBase64, alt: "" },
                                    })
                                  : _vm._e(),
                              ]),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-name overflow overflow-2",
                                    attrs: { title: item.fileName },
                                  },
                                  [_vm._v(_vm._s(item.fileName))]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c("el-col", { attrs: { span: 4 } }, [
                        item.createDate &&
                        item.createDate !== "null" &&
                        item.createDate !== "undefined"
                          ? _c("div", { staticClass: "item-time" }, [
                              _vm._v(
                                _vm._s(
                                  item.createDate
                                    ? _vm.formatToDateTime(item.createDate)
                                    : "-"
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "el-col",
                        {
                          staticClass: "flex items-center",
                          attrs: { span: 2 },
                        },
                        [
                          item.status === "0"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center pointer btn-style",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex items-center pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.regenerate(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-refresh-right",
                                        staticStyle: {
                                          color: "rgba(0, 0, 14, 0.52)",
                                          "font-size": "14px",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-popconfirm",
                                    {
                                      attrs: {
                                        "confirm-button-text": "确认",
                                        "cancel-button-text": "取消",
                                        icon: "el-icon-info",
                                        "icon-color": "red",
                                        title: "确定删除该条数据吗？",
                                        "popper-class": "confirm-delete-popper",
                                      },
                                      on: {
                                        confirm: function ($event) {
                                          return _vm.deleteFile(item.fileId)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center pointer",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                            staticStyle: {
                                              color: "#999999",
                                              "font-size": "14px",
                                              "margin-left": "10px",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : item.status === "1"
                            ? _c(
                                "div",
                                { staticClass: "flex items-center btn-style" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex items-center pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadFile(
                                            item.fileId,
                                            item.fileType,
                                            item.fileName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-download",
                                        staticStyle: {
                                          color: "#1241C9",
                                          "font-size": "14px",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "el-popconfirm",
                                    {
                                      attrs: {
                                        "confirm-button-text": "确认",
                                        "cancel-button-text": "取消",
                                        icon: "el-icon-info",
                                        "icon-color": "red",
                                        title: "确定删除该条数据吗？",
                                        "popper-class": "confirm-delete-popper",
                                      },
                                      on: {
                                        confirm: function ($event) {
                                          return _vm.deleteFile(item.fileId)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center pointer",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                            staticStyle: {
                                              color: "#f56c6c",
                                              "font-size": "14px",
                                              "margin-left": "10px",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : item.status === "2"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center pointer btn-style",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        cursor: "default",
                                        color: "#999999",
                                      },
                                    },
                                    [_vm._v(" 生成中...")]
                                  ),
                                ]
                              )
                            : item.status === "3"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center pointer btn-style",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        cursor: "default",
                                        color: "#999999",
                                      },
                                    },
                                    [_vm._v("已过期")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "page-container" },
      [
        _c("el-pagination", {
          attrs: {
            background: "",
            "page-sizes": [10, 20, 50],
            "page-size": _vm.pageSize,
            "current-page": _vm.pageNum + 1,
            "hide-on-single-page": true,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.totalElements,
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }